import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Button from 'components/Button';
import { useAppSelector } from 'hooks/useStore';

import './index.css';

function DigitalACTBreak({ endBreak }: { endBreak: () => void; }) {
    const [breakTime, setBreakTime] = useState(900);

    const { user } = useAppSelector(state => state.user);

    const formatTime = (time: number) => {
        const duration = moment.duration(time, 'seconds');

        const hours = duration.hours();
        const minutes = (hours && duration.minutes() < 10) ? `0${duration.minutes()}` : duration.minutes();
        const seconds = duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds();

        return hours ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
    }

    useEffect(() => {
        if (!breakTime) endBreak();

        const breakTimer = setInterval(() => {
            setBreakTime(breakTime - 1);
        }, 1000);

        return () => clearInterval(breakTimer);
    }, [breakTime]);

    return (
        <div className='digitalBreak'>
            <p className='digitalBreak__name'>
                {user.firstName} {user.lastName}
            </p>
            <div className='digitalBreak__left'>
                <div className='digitalBreak__timerBox'>
                    <h2 className='digitalBreak__timerText'>
                        Remaining Break Time:
                    </h2>
                    <p className='digitalBreak__timer'>
                        {formatTime(breakTime)}
                    </p>
                </div>
                <Button
                    className='digitalBreak__button'
                    onClick={endBreak}
                >
                    Resume Testing
                </Button>
            </div>
            <div className='digitalBreak__right'>
                <h1 className='digitalBreak__title'>
                    Practice Test Break
                </h1>
                <p className='digitalBreak__text'>
                    You can resume this practice test as soon as you're ready to move on. On test day, you'll wait until the clock counts down. Read below to see how breaks work on test day.
                </p>
                <div className='digitalBreak__hr'></div>
                <h2 className='digitalBreak__title'>
                    Take a Break
                </h2>
                <p className='digitalBreak__text'>
                    You may leave the room, but do not disturb students who are still testing.<span/>
                    Do not exit the app or close your device.<span/>
                    Testing won't resume until you return.<br/><br/>
                </p>
                <h4 className='digitalBreak__text'>
                    Follow these rules during the break:<span/>
                </h4>
                <ol className='digitalBreak__list'>
                    <li>Do not access your phone, smartwatch, textbooks, notes, or the internet.</li>
                    <li>Do not eat or drink in the test room.</li>
                    <li>Do not speak in the test room; outside the test room, do not discuss the exam with anyone.</li>
                </ol>
            </div>
        </div>
    );
}

export default DigitalACTBreak;